// @ts-expect-error TS(7016): Could not find a declaration file for module 'hype... Remove this comment to see the full error message
import { load } from 'hypernova';

import { SsrPayload } from 'ssr/types/SsrPayload';

type Args = {
  name: string;
};

export function ssrHypernovaDeserializePayload({
  name,
}: Args): SsrPayload | undefined {
  const payloads = load(name);
  if (payloads.length === 0) return;

  const payload = payloads[0];
  const { node } = payload;

  if (!node) return;

  return payload as SsrPayload;
}
